import { createApi } from '@reduxjs/toolkit/query/react';
import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { StatisticsProps } from '../components/Statistics/Statistics.props';
import { StatisticsRatingProps } from '../components/StatisticsRating/StatisticsRating.props'
import { constURL } from '../services/enum.services';
import { baseURL } from '../services/api';
import { Dayjs } from 'dayjs';


interface statisticsI {
  // senderType: 'Admin' | 'Web' | 'Water';
  // senderType: 'App' | 'Site';
  senderType: 'App';
  firstDate: Dayjs | null | string;
  lastDate: Dayjs | null | string;
  quesTheme: string;
}

interface statisticsRatingI {
  firstDate: Dayjs | null | string;
  lastDate: Dayjs | null | string;
  quesTheme: string;
}

export const StatisticsAPI = createApi({
  reducerPath: 'statisticsAPI',
  baseQuery: fetchBaseQuery({ baseUrl: baseURL }),
  tagTypes: ['statistics'],
  endpoints: (build) => ({

    getStatistics: build.query<StatisticsProps, statisticsI>({
      query: ({ senderType, firstDate, lastDate, quesTheme }: statisticsI) =>
        `${constURL.STATISTICS}?senderType=${senderType}&firstDate=${firstDate}&lastDate=${lastDate}&quesTheme=${quesTheme}`,
      providesTags: ['statistics'],
    }),
 
    getStatisticsRating: build.query<StatisticsRatingProps, statisticsRatingI>({
      query: ({ firstDate, lastDate, quesTheme }: statisticsRatingI) =>
        `${constURL.RATING_STATISTICS}?&firstDate=${firstDate}&lastDate=${lastDate}&quesTheme=${quesTheme}`,
      providesTags: ['statistics'],
    }),

  }),
});

export const { useGetStatisticsQuery, useGetStatisticsRatingQuery  } = StatisticsAPI;